// extracted by mini-css-extract-plugin
export default {"error":"ProviderModal_error__1LtxI"};